import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { postLogout } from '@perpay-web/fintech/actions/authentication';
import Logout from '@perpay-web/fintech/components/composite/Logout/Logout';

const BorrowerLogoutContainer = () => {
    const dispatch = useDispatch();

    const onMount = useCallback(() => dispatch(postLogout()), [dispatch]);

    return <Logout onMount={onMount} />;
};

export default BorrowerLogoutContainer;
